angular.module('tromanWeb').factory('dialogService', ['$uibModal', 'alertDialog', 'errorDialog', 'Metadata', function ($uibModal, alertDialog, errorDialog, Metadata) {

    var so = {};

    so.confirmAdvanced = function confirmAdvanced(opts) {
        return alertDialog.confirmAdvanced(opts);
    };

    so.confirm = function confirm(message, title) {
        return alertDialog.confirm(message, title);
    };

    so.notify = function notify(message, title) {
        return alertDialog.notify(message, title);
    };

    so.warning = function warning(message) {
        return alertDialog.warning(message);
    };

    so.error = function error(err) {
        return errorDialog.show(err);
    };

    so.editMission = function editMission(mission, existingMissionsToCheck) {
        return $uibModal.open({
            animation: true,
            template: require('../missions/missionEdit.html'),
            controller: 'MissionEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                mission: function () { return mission; },
                existingMissionsToCheck: function () { return existingMissionsToCheck; },
            }
        }).result;
    };

    function updateMission(missions, organization, person) {
        return $uibModal.open({
            animation: true,
            template: require('../missions/missionUpdate.html'),
            controller: 'MissionUpdateController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                missions: function () { return missions; },
                organization: function () { return organization; },
                person: function () { return person; }
            }
        }).result;
    }

    so.updateOrganizationMissions = function updateOrganizationMissions(missions, organization) {
        return updateMission(missions, organization, null);
    };

    so.updatePersonMissions = function updatePersonMissions(missions, person) {
        return updateMission(missions, null, person);
    };

    so.editMandatePeriod = function editMandatePeriod(mandatePeriod) {
        return $uibModal.open({
            animation: true,
            template: require('../mandate/mandateEdit.html'),
            controller: 'MandateEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                mandatePeriod: function () { return mandatePeriod; }
            }
        }).result;
    };

    so.editAward = function editAward(award) {
        return $uibModal.open({
            animation: true,
            template: require('../awards/awardEdit.html'),
            controller: 'AwardEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                award: function () { return award; }
            }
        }).result;
    };

    so.editMissionType = function editMissionType(missionType) {
        return $uibModal.open({
            animation: true,
            template: require('../missionTypes/missionTypeEdit.html'),
            controller: 'MissionTypeEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                missionType: function () { return missionType; }
            }
        }).result;
    };

    so.editParty = function editParty(party) {
        return $uibModal.open({
            animation: true,
            template: require('../parties/partyEdit.html'),
            controller: 'PartyEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                party: function () { return party; }
            }
        }).result;
    };

    so.editDivision = function editDivision(division) {
        return $uibModal.open({
            animation: true,
            template: require('../divisions/divisionEdit.html'),
            controller: 'DivisionEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                division: function () { return division; }
            }
        }).result;
    };

    so.editOrganizationType = function editOrganizationType(organizationType) {
        return $uibModal.open({
            animation: true,
            template: require('../organizationType/organizationTypeEdit.html'),
            controller: 'OrganizationTypeEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                organizationType: function () { return organizationType; }
            }
        }).result;
    };

    so.editEquipment = function editEquipment(equipment) {
        return $uibModal.open({
            animation: true,
            template: require('../equipment/equipmentEdit.html'),
            controller: 'EquipmentEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                equipment: function () { return equipment; }
            }
        }).result;
    };

    so.editWageType = function editWageType(wageType) {
        return $uibModal.open({
            animation: true,
            template: require('../wageType/wageTypeEdit.html'),
            controller: 'WageTypeEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                wageType: function () { return wageType; }
            }
        }).result;
    };

    so.editWageCalculation = function editWageCalculation(wageCalculation) {
        return $uibModal.open({
            animation: true,
            template: require('../wageCalculation/wageCalculationEdit.html'),
            controller: 'WageCalculationEditController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                wageCalculation: function () { return wageCalculation; }
            }
        }).result;
    };

    function showListBuilder(list, definition, title) {
        return $uibModal.open({
            animation: true,
            template: require('../lists/listBuilder.html'),
            controller: 'ListBuilderController as lbc',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                list: function () { return list; },
                definition: function () { return definition; },
                title: function () { return title; }
            }
        }).result;
    }

    so.createPersonList = function createPersonList(list) {
        return showListBuilder(list, Metadata.Person);
    };

    so.createPartyList = function createPartyList(list) {
        return showListBuilder(list, Metadata.Party);
    };

    so.createOrganizationList = function createOrganizationList(list) {
        return showListBuilder(list, Metadata.Organization);
    };

    so.createMissionList = function createMissionList(list) {
        return showListBuilder(list, Metadata.Mission);
    };

    so.createEquipmentList = function createEquipmentList(list, title) {
        return showListBuilder(list, Metadata.Equipment, title);
    };

    so.createAwardList = function createAwardList(list, title) {
        return showListBuilder(list, Metadata.Award, title);
    };

    so.createMissionTypeList = function createMissionTypeList(list) {
        return showListBuilder(list, Metadata.MissionType);
    };

    so.createDivisionList = function createDivisionList(list) {
        return showListBuilder(list, Metadata.Division);
    };

    so.createOrganizationTypeList = function (list) {
        return showListBuilder(list, Metadata.OrganizationType);
    };

    so.createMeetingList = function (list) {
        return showListBuilder(list, Metadata.Meeting);
    };

    so.createAttendanceModelList = function (list) {
        return showListBuilder(list, Metadata.AttendanceModel);
    };

    so.createWageTypeList = function (list) {
        return showListBuilder(list, Metadata.WageType);
    };

    so.createWageCalculationList = function (list) {
        return showListBuilder(list, Metadata.WageCalculation);
    };

    so.createWageGroupList = function (list) {
        return showListBuilder(list, Metadata.WageGroup);
    };

    so.createEmailList = function createEmailList(persons) {
        return $uibModal.open({
            animation: true,
            template: require('./emailList.html'),
            controller: 'EmailListController as emailctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                persons: function () { return persons; }
            }
        }).result;
    };

    so.createReport = function createReport(filter) {
        return $uibModal.open({
            component: 'ergoReportDialog',
            animation: true,
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                filter: function () { return filter; }
            }
        }).result;
    };

    so.setAttendanceMission = function setAttendanceMission(missions, attendance) {
        return $uibModal.open({
            component: 'ergoAttendanceDialog',
            animation: true,
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                missions: function () { return missions; },
                attendance: function () { return attendance; }
            }
        }).result;
    };

    so.addToMissionGroup = function addToMissionGroup(missions, currentMissionGroupId) {
        return $uibModal.open({
            animation: true,
            template: require('../missionGroups/updateMissionGroup.html'),
            controller: 'UpdateMissionGroupController as ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                missions: function () { return missions; },
                currentMissionGroupId: function () { return currentMissionGroupId; },
            }
        }).result;
    };

    so.showPaymentGroup = function (paymentGroup) {
        return $uibModal.open({
            animation: true,
            template: require('../payroll/groupDialog/groupDialog.html'),
            controller: 'GroupDialogController as $ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                paymentGroup: function () { return paymentGroup; },
            }
        }).result;
    };

    so.showCeremony = function (ceremonyId) {
        return $uibModal.open({
            animation: true,
            template: require('../meetings/ceremony/dialog/ceremonyDialog.html'),
            controller: 'CeremonyDialogController as $ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                ceremonyId: function () { return ceremonyId; },
            }
        }).result;
    };

    so.showAttendanceTimeReport = function (attendance, canRecall) {
        return $uibModal.open({
            animation: true,
            template: require('../meetings/timereport/timeReportDialog.html'),
            controller: 'TimeReportDialogController as $ctrl',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                attendance: function () { return attendance; },
                canRecall: function () { return canRecall; }
            }
        }).result;
    };

    return so;
}]);
